import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../assets/css/sign.css";

import logo from "../../assets/AdityaBirlaGroupLogoVector.svg";
import mainBanner from "../../assets/MainBanner.svg";
import { useDispatch } from "react-redux";
//import { setToken } from "../../Redux/Auth/TokenSlice";

import Loader from "../../Components/LoaderAndSpinner/Loader";

import { setToken } from "../../Redux/Auth/TokenSlice";
import { setUser } from "../../Redux/User/UserSlice";

const OTPVerification = () => {
  const [otp, setOtp] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(60);
  const [showResendButton, setShowResendButton] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // Retrieve email from session storage
    const storedEmail = sessionStorage.getItem("email");
    if (storedEmail) {
      setEmail(storedEmail + "@adityabirla.com");
    }
  }, []);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer(timer - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setShowResendButton(true);
    }
  }, [timer]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    try {

      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/validate-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            otp,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();


        const errorMessaged = errorData.message;

        setErrors(errorData.errors || {});
        toast.error(errorMessaged);
        setLoading(false);
        return;
      }

      const data = await response.json();


      sessionStorage.setItem("jwt_token", data.token);
      sessionStorage.setItem("user", JSON.stringify(data.user));
      sessionStorage.setItem("role", JSON.stringify(data.role));
      // Also store role in localStorage as backup
      localStorage.setItem("role", JSON.stringify(data.role));
      dispatch(setToken(data.token)); // Ensure to dispatch the token to the Redux store

      dispatch(setUser(data.user)); // Dispatch user info to Redux store

      setLoading(false);
      navigate("/");
    } catch (error) {
      console.error("Error occurred:", error);
      toast.error("Error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {
    setLoading(true);
    setShowResendButton(false);
    setTimer(60); // Reset the timer
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/resend-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();


        const errorMessage = errorData.message;

        setErrors(errorData.errors || {});
        toast.error(errorMessage);
        setLoading(false);
        return;
      }

      toast.success("OTP resent successfully!");
      setLoading(false);
    } catch (error) {
      console.error("Error occurred:", error);
      toast.error("Error occurred while resending OTP");
      setLoading(false);
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="container  bg-white">
        <div>
          <div className="row signIn-card">
            <div className="col-lg-6 p-0 pt-4 col-md-12 px-4  mb-4 resp-img">
              <img src={mainBanner} alt="bg-image" className="resp-img-img" />
              <img src={logo} className="banner-logo desktop-logo" />
              <div className="banner-text-container">
                <h1 className="banner-text1">Asset Taxonomy Management</h1>
                <h3 className="banner-text2">ATM - version 1.0</h3>
              </div>
            </div>
            <div className="col-lg-6 col-md-12  p-0 px-4 signin-col align-content-center ">
              <h2>Enter OTP</h2>
              <p>Enter the OTP received on your email</p>
              <form
                className="signin-form needs-validation"
                onSubmit={handleSubmit}
                noValidate
              >
                <div
                  className="d-flex flex-column"
                  style={{ marginBottom: "16px", position: "relative" }}
                >
                  <label htmlFor="otp" className="signin-form-label">
                    OTP
                  </label>
                  <input
                    type="text"
                    id="otp"
                    name="otp"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    className={`signin-form-input ${errors.otp ? "is-invalid" : ""
                      }`}
                    placeholder="Enter OTP"
                  />
                  {errors.otp && (
                    <div className="invalid-feedback">{errors.otp}</div>
                  )}

                  {showResendButton ? (
                    <div className="mt-2 resend-button text-center">
                      You didn't receive the OTP?{" "}
                      <a className="" href="" onClick={handleResendOTP}>
                        RESEND
                      </a>
                    </div>
                  ) : (
                    <div className="mt-2 text-center">
                      Resend OTP in {timer} seconds
                    </div>
                  )}
                </div>

                <button type="submit" className="signin-form-button">
                  VERIFY
                </button>
              </form>
            </div>
          </div>
          <div className="d-flex justify-content-between align-content-center  px-4  sign-footer-text">
            <p className="w-100">Copyright all rights reserved {currentYear}</p>
            <div className="w-100 d-flex gap-5 justify-content-end sign-footer-text-1 ">
              <p>Terms Of Use</p>
              <p>Privacy Policy</p>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer autoClose={4000} position={"top-right"} />
    </>
  );
};

export default OTPVerification;
